import { GeneralPropsType } from "@/common/types";
import { useAuth } from "@/contexts/Auth";
import ActivityLoading from "../ActivityLoading/ActivityLoading";
import HomeLoading from "../HomeLoading/HomeLoading";
import Loading from "../Loading";
import RewardLoading from "../RewardLoading/RewardLoading";
import SettingsLoading from "../SettingsLoading/SettingsLoading";
import BranchLoading from "../BranchLoading/BranchLoading";
import EmailBackupLoading from "../EmailBackupLoading";
import { useGlobalData } from "@/contexts/GlobalData";
import ManagementPackageLoading from "../ManagementPackageLoading";
import PortfolioLoading from "../PortfolioLoading";
import { memo } from "react";
export interface RequireDataPropsType extends GeneralPropsType {
  showLoading?: boolean;
  keyPage?: string;
}
function RequireData({
  children,
  showLoading,
  keyPage
}: RequireDataPropsType) {
  if (showLoading) {
    return <Loading className="relative z-[9999]" />;
  }
  return <>{children}</>;
}
export default memo(RequireData);